// A two-state view switch: the default half, and the other one.
//
// Not a filter over data — a filter narrows what you are looking at, while this swaps
// which of two complete sets is on screen. The distinction matters for what it promises:
// the half you are not looking at is one click away and nothing about it has changed.
//
// Extracted because the job status toggle needs it in three places at once (the one-off
// projects screen, the retainer's jobs section and the client card's work tree) and
// three copies of the same six lines is exactly what the DRY rule exists to stop. The
// older `seg` toggles on the clients, retainers, leads and board screens still spell it
// out inline; they are untouched here rather than swept up in an unrelated change.
import Button from './Button';

export default function ViewToggle({ value, onChange, offLabel, onLabel }) {
  return (
    <div className="seg">
      <Button small variant={value ? 'subtle' : ''} onClick={() => onChange(false)}>
        {offLabel}
      </Button>
      <Button small variant={value ? '' : 'subtle'} onClick={() => onChange(true)}>
        {onLabel}
      </Button>
    </div>
  );
}
